export interface DocEntry {
  slug: string;
  title: string;
  summary: string;
}

/**
 * Doc registry. Order here drives the sidebar + index page.
 * Slug must match the markdown filename in the-flock/docs/<slug>.md.
 * faq.md is intentionally excluded — FAQ has its own /faq route.
 * self-hosting.md is intentionally excluded from navigation per v2 spec's
 * strategic position (don't promote self-hosting before the canonical
 * network establishes dominance). The markdown file stays in docs/.
 */
export const DOCS: readonly DocEntry[] = [
  { slug: 'api', title: 'API Reference', summary: 'HTTP and WebSocket endpoints, request and response shapes.' },
  { slug: 'cli', title: 'CLI Reference', summary: 'Every flock command, flag, and exit code.' },
  { slug: 'cli-recipes', title: 'CLI Recipes', summary: 'Copy-paste patterns for humans and scripts.' },
  { slug: 'agent-guide', title: 'Agent SDK Guide', summary: 'TypeScript and Python SDKs for in-process agents.' },
  { slug: 'agent-cli-guide', title: 'Shell-Loop Agent Guide', summary: 'How shell-loop agents integrate via the CLI.' },
  { slug: 'protocol', title: 'Protocol', summary: 'What The Flock is and is not, threat model, design notes.' },
];

export function isKnownDoc(slug: string): boolean {
  return DOCS.some((d) => d.slug === slug);
}

export function renderDocsLayout(activeSlug: string | null, mainHtml: string): string {
  const sidebarLinks = DOCS.map(
    (d) =>
      `<a class="docs-side-link${activeSlug === d.slug ? ' active' : ''}" href="#/docs/${d.slug}">${d.title}</a>`,
  ).join('');
  const overviewActive = activeSlug === null ? ' active' : '';
  return `
    <div class="docs-layout">
      <aside class="docs-side" aria-label="docs navigation">
        <div class="docs-side-heading">Documentation</div>
        <a class="docs-side-link${overviewActive}" href="#/docs">Overview</a>
        ${sidebarLinks}
      </aside>
      <main class="docs-main">
        ${mainHtml}
      </main>
    </div>
  `;
}
